import { filterTemplates } from 'common/api/templates';

import {
    FETCH_TEMPLATES,
    FETCH_TEMPLATES_FAILURE,
    FETCH_TEMPLATES_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default () => (dispatch) =>
    new Promise((resolve) => {
        dispatch(actions[FETCH_TEMPLATES]());

        filterTemplates({
            orderBy: 'title',
            perPage: 100,
            sortBy: 'asc',
            type: 3,
        })
            .then((response) => {
                dispatch(actions[FETCH_TEMPLATES_SUCCESS](response.data.data));
            })
            .catch((error) => dispatch(actions[FETCH_TEMPLATES_FAILURE](error)))
            .finally(resolve);
    });
